import { Box, Text, Heading, Stack, ModalContent, ModalCloseButton, ButtonProps, ModalProps } from '@chakra-ui/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { ControllableModal } from 'components/Modal';

interface IConfirmationModal {
  title: string;
  subTitle?: string;
  confirmButtonLabel: React.ReactNode | string;
  confirmButtonProps?: ButtonProps;
  cancelButtonLabel?: React.ReactNode | string;
  cancelButtonProps?: ButtonProps;
  isOpen: boolean;
  onClose: () => void;
  hideCloseButton?: boolean;
  body?: React.ReactNode;
  modalProps?: ModalProps;
}

const ConfirmationModal: React.FC<IConfirmationModal> = ({
  title,
  subTitle,
  body,
  confirmButtonLabel,
  confirmButtonProps,
  cancelButtonLabel,
  cancelButtonProps = '',
  isOpen,
  onClose,
  hideCloseButton = false,
  modalProps,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <ControllableModal isOpen={isOpen} onClose={onClose} {...modalProps}>
      <ModalContent p="6" pt="10" textAlign="center">
        {!hideCloseButton && <ModalCloseButton />}
        <Heading as="h6" size="md" mb="2" data-testid="modal-title">
          {title}
        </Heading>
        <Text color="gray.600" data-testid="modal-subtitle">
          {subTitle}
        </Text>
        {body && <Box>{body}</Box>}{' '}
        <Stack direction="row" justifyContent="center" mt="6">
          <Button variant="ghost" minW="170px" onClick={onClose} {...cancelButtonProps} data-testid="cancel-button">
            {cancelButtonLabel ? cancelButtonLabel : t('common:cancel')}
          </Button>
          <Button minWidth="170px" fontWeight="semibold" {...confirmButtonProps} data-testid="confirm-button">
            {confirmButtonLabel}
          </Button>
        </Stack>
      </ModalContent>
    </ControllableModal>
  );
};

export default memo(ConfirmationModal);
